import { Component, DestroyRef, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';
import { Router, RouterOutlet } from '@angular/router';
import { dismissPreBootstrapLoader } from '@infinitform/shared-ui';
import { WebSocketService, AuthService, WebSocketEventType, EmbeddedBridgeService } from '@infinitform/editor-features';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  private webSocketService = inject(WebSocketService);
  private authService = inject(AuthService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef);
  private embeddedBridge = inject(EmbeddedBridgeService);

  ngOnInit(): void {
    dismissPreBootstrapLoader({ finishIntro: true });

    if (!environment.PRODUCTION) {
      document.title = `(${environment.ENV_LABEL}) InfinitForm`;
    }

    this.webSocketService
      .onMessage<{ enabled: boolean; updatedAt?: string | null }>()
      .pipe(
        filter((message) => message?.type === WebSocketEventType.MAINTENANCE_STATUS),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((message) => {
        if (this.authService.isAdmin()) {
          return;
        }
        if (message?.data?.enabled === true) {
          if (this.router.url !== '/maintenance') {
            this.router.navigate(['/maintenance']);
          }
          return;
        }
        if (message?.data?.enabled === false) {
          if (this.embeddedBridge.isEmbedded) {
            if (this.router.url === '/maintenance') this.embeddedBridge.navigateHost('/user/projects');
            return;
          }
          const target = `${environment.FRONTEND_ADDRESS}/user/projects`;
          if (window.location.href !== target) {
            window.location.assign(target);
          }
        }
      });
  }

  ngOnDestroy(): void {
    this.webSocketService.disconnect();
  }
}
